import { Body } from "./Body";
import { Footer } from "./Footer";

const TargetTemplateStep = {
  Body,
  Footer,
  title: 'Target template'
};

export { TargetTemplateStep };